/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2024-10-22 10:28:55
 * @LastEditors: yangzuhui yangzuhui@jtexpress.com
 * @LastEditTime: 2026-04-08 21:12:35
 * @Description: file content
 */
const en = {
  订单号: 'Order number',
  生活用品: 'Daily necessities',
  期待送达方式: 'Expected delivery method',
  '计费重量(KG)': 'Billing weight (KG)',
  基础运费: 'Basic shipping fee',
  优惠费用: 'Discount fee',
  继续下单: 'Continue to place order',
  寄快递: 'create shipment',
  物品信息: 'Parcel info',
  签名: 'Sign',
  预览: 'Preview',
  条款与条件: 'Conditions and terms',
  寄件人信息: 'Sender info',
  收件人信息: 'Receiver info',
  下单成功: 'checkout success',
  寄件人: 'Sender',
  点击填写寄件人信息: 'Click to fill sender info',
  收件人: 'Receiver',
  点击填写收件人信息: 'Click to fill in shipper info',
  物品价值:'Goods Value',
  保价费:'Insurance Fee',
  快递公司:'Express company',
  扫码下单:'Scan the code to place an order',
  期望送达方式:'Expected delivery method',
  查看收件人附近的站点:'View nearby stations for receiver',
  上门派送: 'Door-to-door delivery',
  驿站自提: 'Self-pickup at station',
  无要求: 'No requirements',
  快件类型: 'Parcel Type',
  '我已阅读，理解并同意': 'I have read, understand and areed to the',
  合计: 'Total',
  明细: 'Detail',
  下单: 'submit',
  费用明细: 'Fee details',
  运费: 'Shipment fee',
  下载: 'Download',
  请输入寄件人姓名: 'Please enter sender name',
  请选择所在地区: 'Please select district',
  请输入寄件人详细地址: 'Please enter sender detailed address',
  请输入寄件人手机号码: 'Please enter sender mobile number',
  请输入收件人姓名: 'Please enter the recipient name',
  请输入收件人详细地址: 'Please enter the recipient detailed address',
  请输入收件人手机号码: 'Please enter recipient phone number',
  物品价值不能为空: 'Item value cannot be empty',
  '没有签名信息，无法保存': 'No signature information, unable to save',
  未获取到报价: 'No quote was obtained',
  '是否确定下单？': 'Are you sure to place an order?',
  确定: 'OK',
  取消: 'Cancel',
  请输入手机或固定电话: 'Please enter mobile or telephone',
  请输入邮箱: 'Please input email address',
  清空当前信息: 'Clear current information',
  请输入10位手机号: 'Please enter a 10 digits phone number',
  物品类型: 'Item type',
  违禁物品清单: 'List of prohibited items',
  重量: 'Weight',
  数量: 'Quantity',
  物品类别: 'Item type',
  袋子规格: 'Pouch Size',
  文件: 'file',
  数码产品: 'digital product',
  食品: 'food',
  服装: 'clothes',
  其他: 'Others',
  不需要袋子: 'No need for Pouch',
  小: 'Small',
  中: 'Middle',
  大: 'Large',
  加载中: 'Loading',
  保存成功: 'Successfully saved',
  '请确认已保存二维码图片?':
    'Please confirm that the QR code image has been saved?',
  '请出示二维码给站点人员，进行扫描下单':
    'Please show the QR code to the site staff for scanning and placing the order',
  订单编号: 'Order number',
  没有更多了: 'No more',
  暂无数据: 'No data',
  清空: 'Empty',
  新用户首单寄免费: 'New Customer free to shipping',
  优惠类型: 'Discount type',
  优惠金额: 'Discount amount',
  '退出后将不享受新用户首单免费寄，是否确认？':
    'After logging out, new users will no longer enjoy free shipping for their first order. Still want to exit?',
  输入验证码: 'Please enter verification code',
  请输入图形验证码: 'Please enter the captcha',
  获取验证码: 'Verification code',
  新用户首单需获取短信验证码校验即可享受免费寄:
    'New users need to obtain an SMS verification code for their first order to enjoy free shipping',
  验证码错误或过期: 'Incor or expired verification code ncor',
  '参数无效:运费为0,请联系管理员':
    'Shipping fee is 0, please contact the administrator',
  '参数无效:物品重量不能超出50kg': 'The weight of the item cannot exceed 50kg',
  Super增值费: 'Super Fee',
  航空违禁品: 'Aviation prohibited items',
  不可抗力规则描述: 'Unforeseen circumstances rules',
  '当前选择Small包裹,重量应在3kg以下':
    'Current selection is Small pouch,\n weight should be below 3kg',
  '当前选择Medium包裹,重量应在5kg以下':
    'Current selection is Medium pouch,\n  weight should be below 5kg',
  '当前选择Large包裹,重量应在8kg以下':
    'Current selection is Large pouch,\n  weight should be below 8kg',
  super件重量不能超过5kg: 'Super parcel weight cannot exceed 5kg',
  '我已线下汇款，下一步': 'I have transferred the money offline, next step',
  提交: 'Submit',
  操作流程: 'Operation process',
  通过推荐的银行汇款至我们的银行账户:
    'Transfer the funds to our bank account through the recommended bank',
  '登录您的APP，创建充值申请单':
    'Log in to your app and create a top-up request',
  '打开个人中心-我的钱包，找到预付款充值功能':
    'Open the personal center - My Wallet, and find the prepaid top-up function',
  '转账完毕后，填写转账申请，填写转账信息':
    'After the transfer is completed, fill in the transfer application and transfer information',
  上传凭证: 'Upload proof of payment',
  提交申请: 'Submit the application',
  '我们的财务人员确认资金到账后，会通过充值申请，并为您充值':
    'After our financial staff confirms the funds have arrived, they will approve the recharge application and recharge for you',
  线下汇款: 'Offline payment',
  填写申请: 'Enter Details',
  充值结果: 'Top-up result',
  银行名称: 'Bank name',
  银行账户: 'Bank account',
  收款人: 'Payee',
  汇款备注: 'Payment reference',
  上传凭证图片: 'Upload image of the receipt',
  请上传如图所示的银行汇款回单照片:
    'Please upload the bank transfer receipt photo',
  预约日期: 'Appointment date',
  选择日期: 'Select date',
  选择时间: 'Select time',
  银行列表: 'Bank list',
  请选择汇款银行: 'Please select the bank for the transfer',
  请输入汇款银行账户: 'Please provide the bank account for the transfer',
  请输入汇款人姓名: "Please input the sender's name",
  '充值金额:0.01~50000.00': 'Recharge amount: 0.01~50000.00',
  请选择实际汇款时间: 'Please select the actual transfer time',
  收据: 'Receipt',
  上传成功: 'Upload successful',
  上传失败: 'Upload failed',
  '正在审核中，预计1～2个工作日内到账，请您耐心等待。您可在申请记录中查看。':
    'Currently under review, the funds are expected to arrive within 1 to 2 business days. Please be patient. You can check the application record for updates.',
  申请编号: 'Application number',
  申请金额: 'Application amount',
  汇款时间: 'Transfer time',
  凭证: 'Proof',
  财务审核通过: 'Financial audit approved',
  提交申请成功: 'Application submitted successfully',
  提交申请失败: 'Application submission failed',
  财务审核不通过: 'Financial audit failed',
  充值确认中: 'Recharge being confirmed',
  注意事项: 'Important notes',
  '为了确保您审核成功，请您在打款时仔细核对官方账号填写是否正确':
    '1.To ensure successful review, please carefully check if the official account details are filled in correctly when making the payment',
  请您务必在填汇款备注中填写您的驿站编码以便我们核对您的汇款信息:
    '2.Kindly make sure to include your station code in the payment reference to allow us to verify your transaction information',

  兑换时间: 'Redemption time',
  确认送达: 'Confirm delivery',
  取消兑换: 'Cancel exchange',
  是否取消兑换: 'Would you like to cancel the exchange?',
  是否确认送达: 'Confirm delivery?',
  提示: 'Hint',
  已取消: 'Canceled',
  取消兑换成功: 'Canceled',
  已确认到达: 'Confirmed arrival',
  筛选: 'Filter',
  兑换记录: 'Exchange',
  充值记录: 'Top-up',
  '兑换状态(多选)': 'Exchange status (multiple selections)',
  '状态(多选)': 'Status (multiple selections)',
  全部: 'All',
  处理中: 'Processing',
  已驳回: 'Rejected',
  待确认: 'To be confirmed',
  已确认: 'Confirmed',
  审核中: 'Under review',
  成功: 'Success',
  失败: 'Failed',
  剩余积分: 'Remaining points',
  '积分不足，去充值': 'Insufficient points, redeem',
  兑换: 'Exchange',
  我的积分: 'My points',
  积分兑换: 'Points Redeem',
  充值积分可兑换物料: 'Recharge points to redeem materials',
  积分充值: 'Points recharge',
  积分兑换物料: 'Redeem your Points',
  兑换成功: 'Redemption successful',
  兑换须知: 'Redemption instructions',
  商品详情: 'Product details',
  订单详情: 'Order details',
  实付积分: 'Actual points paid',
  '姓名长度为1-50位': 'The name length is between 1 and 50 characters',
  '银行账号长度为1-50位':
    'The bank account number length is between 1 and 50 characters',
  '请输入0.01到50000.00之间的金额':
    'Please enter an amount between 0.01 and 50000.00',
  充值成功: 'Recharge successful',
  积分明细: 'Points details',
  从: 'From',
  到: 'To',
  时间: 'Time',
  '1.积分一经兑换不可退还,请谨慎兑换':
    'Once points are redeemed, they are non-refundable. Please redeem carefully.',
  '2.兑换成功后,平台将在5个工作日内送达,请耐心等待':
    'After the exchange is successful, the platform will deliver it within 5 business days. Please be patient.',
  汇款人: 'Sender',
  本月达成情况: 'Achievement Of Month',
  '奖励(积分)': 'Rewards (Points)',
  增长量: 'Increase  Volume',
  上月揽收: 'LMC',
  本月揽收: 'TMC',
  冲单激励: 'Boost Order Bonus',
  上月奖励排行: 'Rank Of Last Month',
  排名: 'Ranking',
  站点名称: 'Station name',
  兑换结果: 'Redemption Result',
  可在兑换记录中查看: 'Redepmtion History ',
  支付失败: 'Payment Failed',
  兑换失败: 'Payment Failed',
  继续兑换: 'Go to Exchange',
  去查看: 'See More',
  查看其他物料商品: 'View Items',
  充值失败: 'Recharge failed',
  请输入正确的金额: 'Please enter the correct amount',
  兑换方式: 'Redemption Methods',
  赠送积分: 'Gifted Points',
  充值积分: 'Purchased Points',
  剩余赠送积分: 'Remaining Gifted Points',
  剩余充值积分: 'Remaining Purchased Points',
  删除: 'Delete',
  'JMS系统驿站账户未开账，请联系管理员':
    'The JMS system station account has not been opened, please contact the administrator',
  '积分充值财务异常,请联系客服':
    'Points recharge financial abnormality, please contact customer service',
  不存在审核中的积分充值记录: 'No record of recharging points under review',
  不存在处理中的兑换记录: 'No exchange records in process',
  参数积分总价与实际总价不符:
    'The total price of parameter points does not match the actual total price',
  '账户中积分余额不足,请充值':
    'Insufficient points in your account, please recharge your account',
  物料申请数据未找到: 'Material request data not found',
  '物料兑换申请已被审核,无法取消':
    'The material exchange application has been reviewed and cannot be cancelled',
  物料信息未找到: 'Material information not found',
  '积分充值失败,请联系客户':
    'Points recharge failure, please contact the customer',
  '积分充值金额必须要在0.01~50000.00范围内':
    'The amount of points recharge must be within the range of 0.01~50000.00',
  '当前物料兑换信息无法取消兑换,请刷新数据':
    'The current material exchange information cannot be cancelled, please refresh the data',
  '问题反馈已回复,请勿重复提交':
    'Feedback has been answered, please do not resubmit',
  未知错误: '',
  订单来源: 'Order source',
  重置: 'Reset',
  总运费: 'Total freight',
  寄件提成: 'Commission for Sending Packages',
  揽收量汇总: 'Collection Volume Summary',
  '提成金额汇总(PHP)': 'Summary of commission amount (PHP)',
  平台件: 'Platform Packages',
  回退件: 'Return Packages',
  散户件: 'Retail Packages',
  散户: 'Retail Packages',
  运单编码: 'Waybill Number',
  请输入运单编码: 'Please enter the waybill number',
  订单来源类型: 'Order Source Type',
  寄件日期: 'Shipment Date',
  入库日期: 'Inbound Date',
  时间间隔不能超过31天: 'The time interval should not exceed 31 days',
  结束日期不能早于开始日期:
    'The end date cannot be earlier than the start date',
  提成金额: 'Commission Amount',
  充值金额无法退款: '3.Recharged funds are not eligible for a refund',
  '确认进行兑换吗？': 'Are you sure you want to exchange?',
  确认: 'Confirm',
  平台件取消上传: 'Cancel uploading of platform files',
  取消时间: 'cancel time',
  审核时间: 'Review time',
  寄件入库时间: 'Delivery and storage time',
  已完成: 'Completed',
  待上传: 'Pending upload',
  查看详情: 'Details',
  编辑: 'edit',
  上传: 'Upload',
  待审核: 'Pending review',
  TermOfUse: 'Term of Use',
  privacyPolicy: 'Privacy Policy',
  签收照片: 'Receipt Photo',
  上传确认图片: 'Upload Confirmation Image',
  总计: 'Total',
  请选择: 'Please select',
  服务站点: 'Service Points',
}

export default en
